import React from 'react';
import bgImage from '../Assets/Images/analog-landscape-city-with-buildings.jpg';

export default function Hero() {
  return (
    <section className="relative bg-black h-[600px]">
      <img
        src={bgImage}
        alt="Smiling children"
        className="absolute inset-0 w-full h-full object-cover brightness-50 opacity-70"
      />
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white">
        <h1 className="text-5xl font-bold mb-4">
          Our Core Values
        </h1>
        <p className="text-xl mb-8 max-w-2xl">
          At RamaDreams Real Estate, we aim to redefine the real estate industry in Africa through our core values.
        </p>
        <button className="bg-primary hover:bg-secondary text-white px-6 py-3 rounded-lg text-lg">
          Join Us
        </button>
      </div>
    </section>
  );
}
